import { Component, inject, input, OnInit } from '@angular/core';
import { ChartType } from 'chart.js';
import { v4 } from 'uuid';
import { TableApiService } from '../../../services/table/table-api.service';
import { TableConfig, TABLE_CONFIG } from '../table-config';
import {
  ResponseData,
  TABLE_DATA_PROVIDER,
  RowAction,
  GlobalAction,
  CellColoring,
  CustomTableCell,
  TableRow,
} from '../table.interface';
import { TableComponent } from '../table.component';
import { StaticDataProviderService } from '../../../services/table/static-data-provider.service';

@Component({
  selector: 'app-static-table',
  imports: [TableComponent],
  template: `<app-table />`,
  providers: [
    { provide: TABLE_CONFIG, useExisting: StaticTableComponent },
    {
      provide: TABLE_DATA_PROVIDER,
      useClass: StaticDataProviderService,
    },
  ],
})
export class StaticTableComponent implements TableConfig, OnInit {
  // ----------- inputs ---------------------------

  data = input.required<ResponseData>();
  name = input<string>(v4().split('-')[0]);
  controls = input<boolean>(true);
  static = input<boolean>(false);
  canExport = input<boolean>(true);
  canCopy = input<boolean>(true);
  canSelect = input<boolean>(false);
  selectOptions = input<GlobalAction>();
  chartType = input<ChartType>('bar');
  groupCells = input<boolean>(false);
  hasIndexCol = input<boolean>(false);
  actionCol = input<RowAction[]>([]);
  chartColumn = input<string>();
  coloring = input<CellColoring>();
  customCells = input<CustomTableCell[]>([]);
  hasChartView = input<boolean>(true);
  onRowClick = input<(Row: TableRow) => void>();
  defaultSort =  input<Record<string, 'asc' | 'desc'>>({});
  DeletedRowsStyle = input<boolean>(false);
  
  // ---------------- services -----------------------
  dataProviderService = inject(
    TABLE_DATA_PROVIDER
  ) as StaticDataProviderService;
  // ----------- Managing state changes ---------------

  ngOnInit() {
    this.dataProviderService.initialize(this.data());
  }
}
